(() => {
  const config = document.getElementById('mxpro-finder-language');
  if (!config) return;
  const labels = JSON.parse(config.textContent);
  const fields = { easysearch_field_28411: 'make', easysearch_field_28412: 'model', easysearch_field_28410: 'year' };
  const attached = new WeakSet();
  const setText = (element, text) => {
    if (element && (element.textContent !== text || element.querySelector('font'))) element.textContent = text;
  };
  function localize(container) {
    container.classList.add('notranslate');
    container.setAttribute('translate', 'no');
    container.querySelectorAll('select').forEach(select => {
      const field = fields[select.id];
      if (!field) return;
      select.classList.add('notranslate');
      select.setAttribute('translate', 'no');
      setText(container.querySelector(`label[for="${select.id}"]`), labels[field]);
      for (const option of select.options) {
        // App values are the authoritative make/model/year, never translated names.
        setText(option, option.value ? option.value : labels[`select_${field}`]);
      }
    });
    setText(container.querySelector('.easysearch-btn-search'), labels.search);
    setText(container.querySelector('.easysearch-btn-reset'), labels.reset);
    setText(container.querySelector('[data-easysearch-action="garage-add-to-garage"] .easysearch-btn-title'), labels.garage);
  }
  function attach(container) {
    if (attached.has(container)) return;
    attached.add(container);
    localize(container);
    const observer = new MutationObserver(() => {
      observer.disconnect();
      localize(container);
      observer.observe(container, { childList: true, subtree: true, characterData: true });
    });
    observer.observe(container, { childList: true, subtree: true, characterData: true });
  }
  function discover(root) {
    if (root.nodeType !== 1) return;
    if (root.matches('.easysearch-container')) attach(root);
    root.querySelectorAll('.easysearch-container').forEach(attach);
  }
  discover(document.documentElement);
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) discover(node);
  }).observe(document.body, { childList: true, subtree: true });
})();
